<template>
  <footer class="footer" :class="{ 'is-open' : footerIsOpen }">
    <div class="footer__content--left">
      © 2020 . <span>Alessandra Zanghi Studio . destination wedding consultant.</span>
    </div>
    <div
      v-hover-scale-mouse
      data-apollo-hover
      class="footer__content--right">
      <div class="privacy">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.iubenda.com/privacy-policy/18990984">
          Privacy
        </a>
        <div ref="line" class="privacy__line"/>
      </div>
      .
      <div class="cookie">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.iubenda.com/privacy-policy/18990984/cookie-policy">
          Cookies
        </a>
        <div ref="line" class="cookie__line"/>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppFooter',
  computed: {
    ...mapState(['footerIsOpen']),
  },
};
</script>

<style scoped lang="scss">
.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: -0px;
  padding: 4.2vw 12.4vw;
  width: 100%;

  z-index: 15;

  display: flex;
  justify-content: space-between;
  align-items: center;

  color: $color-dark;

  background-color: $color-primary;

  transform: translateY(100%);
  transition: transform 1s cubic-bezier(0.645, 0.045, 0.355, 1);

  @include mq($until: ds) {
    font-size: 14px;
    padding: calc(9.2vw - 1em) 12.4vw;
  }

    @include mq($until: ipadP) {
    padding: calc(10.2vw - 1em) 12.4vw;
    font-size: 14px;
  }

    @include mq($until: ipadP) {
    padding: calc(10.2vw - 0.9em) 12.4vw;
    width: auto;
    minn-height: 27px;
    box-sizing: content-box;
    justify-content: flex-end;
  }

  @include mq($until: mobile) {
    padding: calc(10.2vw - 0.8em) 12.4vw;
  }

  &__content--left,
  a {
    &::-moz-selection { color: $color-accent}
    &::selection { color: $color-accent; }

    @include mq($until: ipadP) {
       margin-right: 4px;
    };

    & span {
     @include mq($until: ipadP) {
       display: none
     };
    }
  }

  &.is-open {
    transform: translateY(0);
  }

  &__logo {
    height: 2rem;
    margin-right: 2rem;
  }
}

.privacy,
.cookie {
  position: relative;
  display: inline-block;

  vertical-align: bottom;

  overflow: hidden;

  &:hover .privacy__line,
  &:hover .cookie__line {
    &::before {
      transform: translate3d(102%, 0, 0);
      opacity: 1;
    }

    &::after {
      transition: transform 0.4s cubic-bezier(.165, .84, .44, 1);
      transition-delay: 0.3s;
      transform: translate3d(0%, 0, 0);
      opacity: 1;
    }
  }

  &__line {
    display: block;
    position: absolute;
    bottom: 1px;
    left: 0;
    width: 100%;
    height: 1px;

    &::before,
    &::after {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;

      background: $color-dark;
    }

    &::before {
      transform: translate3d(0%, 0, 0);
      opacity: 1;
      transition: transform 0.4s cubic-bezier(.165, .84, .44, 1);
    }

    &::after {
      transform: translate3d(-102%, 0, 0);
      opacity: 0;
    }
  }
}
</style>
